import { trackEvent } from '@/api/track';

export type ProductSalesTrackingData = Record<
  string,
  string | number | boolean | null | undefined | string[] | number[] | boolean[]
>;

export const trackProductSalesEvent = (
  eventCode: string,
  eventData: ProductSalesTrackingData = {},
) => {
  trackEvent({
    eventCode,
    eventData: JSON.stringify(eventData),
  });
};

const normalizeMaybeUrl = (value?: string | null) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const getTrackingUrlHost = (value?: string | null) => {
  try {
    return new URL(normalizeMaybeUrl(value)).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
};

export const getTrackingSourceUrlType = (value?: string | null) => {
  try {
    const parsed = new URL(normalizeMaybeUrl(value));
    const pathname = parsed.pathname.toLowerCase();
    if (pathname.includes('/products/') || pathname.includes('/product/')) return 'product';
    if (pathname.includes('/collections/') || pathname.includes('/collection/'))
      return 'collection';
    if (!pathname || pathname === '/') return 'store_home';
    return 'commerce_page';
  } catch {
    return value ? 'invalid' : 'empty';
  }
};

export const bucketLength = (value?: number | null) => {
  const length = Number(value || 0);
  if (length <= 0) return '0';
  if (length <= 1000) return '1-1k';
  if (length <= 5000) return '1k-5k';
  if (length <= 20000) return '5k-20k';
  if (length <= 100000) return '20k-100k';
  return '100k+';
};

export const getTrackingErrorInfo = (error: unknown) => {
  if (error && typeof error === 'object') {
    const record = error as Record<string, unknown>;
    const code =
      String(record.code || record.errorCode || record.status || record.name || '').trim() || '';
    const message =
      String(record.message || record.errorMessage || record.msg || '').trim() || String(error);

    return {
      errorCode: code,
      errorType: code || record.name ? String(record.name || code) : 'unknown_error',
      reason: message,
    };
  }

  return {
    errorCode: '',
    errorType: 'unknown_error',
    reason: String(error || 'unknown_error'),
  };
};
